import React from "react";
import "./About.css";
import myimage from "../../assets/About/myimage.png";
import endline from "../../assets/About/endline.svg";

const About = () => {
  return (
    <section className="section2" id="about">
      <div className="aboutintroContainer">
        <div className="abouttitlecard">
          <h1 className="aboutsectionTitle">
            about<span className="dotcolor">.</span>
          </h1>
        </div>
        <div className="imagecontainer">
          <img src={myimage} alt="" className="myimage" />
          <div className="namecard">
            <h2 className="intro">
              Hey there! I'm Anu<span className="dot">. </span>
            </h2>
            <h3 className="myrole">
              Creative Front End Developer<span className=""></span>
            </h3>
          </div>
        </div>
        <div className="aboutdescription">
          <p className="aboutpara1">
            I'm a creative developer with a strong focus on user experience.
            Having transitioned from test engineering to front-end development,
            I'm excited to explore the dynamic world of web design and
            development. My creative mind is constantly buzzing with new ideas,
            and I'm eager to bring them to life through coding and design
            <span className="peaceimage">! </span>
          </p>
          <p className="aboutpara2">
            So, if you're looking for someone who can blend creativity with
            technical skills, I'm your gal <span className="galimage">! </span>
            <span className="aboutpara last">
              Let's create something awesome together
              <span className="awesomeimage">! </span>
            </span>
          </p>
        </div>
        <div className="aboutdescription">
          <p className="aboutpara3">
          My tech stack includes HTML, CSS, Bootstrap, JavaScript, and React. For design, I use Figma and Procreate.
          </p>
        </div>
        <div className="aboutdescription">
          <p className="aboutpara4">
            Beyond the tech world, my passion lies in&nbsp;
            <span className="pencilimage">
              <a
                href="http://www.behance.net/anupreetha"
                title="behance profile"
                target="_blank"
                rel="noreferrer"
                className="behanceprofile anchorlink"
              >
                 sketching
              </a>
              
            </span>
            <span className="aboutpara5 last2">
              and the endless humor of memes. I love to unleash my inner artist,
               <span className="quirkyquote" title="everything's better with a little background music! 😉"> jam to music</span>, explore Pinterest and conquer the Duolingo
              challenge.{" "}
              <span
                className="lastline duolingoimg"
                title='"Hallo, wie geht&apos;s?" - "Hello, how are you?" in German. It&apos;s a common greeting used to inquire about someone&apos;s well-being.'
              >
                (hallo, wie geht&apos;s?)
              </span>
            </span>
          </p>
        </div>
        <div className="resumeButton">
          <a href="https://drive.google.com/file/d/1nyEHEj1C8fQ2_AHZJ3cACaP9WGp-CXBk/view?usp=sharing" alt="" className="anchorlink">
            resume
          </a>
        </div>
        <img src={endline} alt="" className="endline" />
      </div>
    </section>
  );
};

export default About;
